<template>
    <div>
        <div>
            <ul class="nav nav-tabs nav-justified">
                <li class="nav-item" v-if="accessRights.patientRegistry">
                    <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Регистр ЛРАС</a>
                </li>
                <li class="nav-item" v-if="accessRights.groupOfRisk">
                    <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">Группа риска</a>
                </li>
                <li class="nav-item" v-if="accessRights.routing">
                    <a class="nav-link" @click.prevent="setActive('tab3')" :class="{ active: isActive('tab3') }" href="#tab3">Маршрутизация ЛРАС</a>
                </li>
                <li class="nav-item" v-if="accessRights.serviceProviders">
                    <a class="nav-link" @click.prevent="setActive('tab4')" :class="{ active: isActive('tab4') }" href="#tab4">Поставщики услуг</a>
                </li>
                <li class="nav-item" v-if="accessRights.employment">
                    <a class="nav-link" @click.prevent="setActive('tab5')" :class="{ active: isActive('tab5') }" href="#tab5">Трудоустройство ЛРАС</a>
                </li>
                <li class="nav-item" v-if="accessRights.patientRegistry || accessRights.groupOfRisk">
                    <a class="nav-link" @click.prevent="setActive('tab6')" :class="{ active: isActive('tab6') }" href="#tab6">По заданным параметрам</a>
                </li>
            </ul>
        </div>


        <div class="tab-content mt-4" id="myTabContent">
            <div class="tab-pane fade" v-if="accessRights.patientRegistry" :class="{ 'active show': isActive('tab1') }" id="tab1">
                <report-ras></report-ras>
            </div>
            <div class="tab-pane fade" v-if="accessRights.groupOfRisk" :class="{ 'active show': isActive('tab2') }" id="tab2">
                <report-poll></report-poll>
            </div>
            <div class="tab-pane fade" v-if="accessRights.routing" :class="{ 'active show': isActive('tab3') }" id="tab3">
                <report-routing/>
            </div>
            <div class="tab-pane fade" v-if="accessRights.serviceProviders" :class="{ 'active show': isActive('tab4') }" id="tab4">
                <report-service-providers></report-service-providers>
            </div>
            <div class="tab-pane fade" v-if="accessRights.employment" :class="{ 'active show': isActive('tab5') }" id="tab5">
                <report-vacancy></report-vacancy>
            </div>
            <div class="tab-pane fade" v-if="accessRights.patientRegistry || accessRights.groupOfRisk" :class="{ 'active show': isActive('tab6') }" id="tab6">
                <report-with-params :accessRights="accessRights" :nn="nn"></report-with-params>
            </div>
        </div>
    </div>
</template>
<script>
import ReportPoll from "../components/ReportPoll";
import ReportRas from "../components/ReportRas";
import ReportServiceProviders from "../components/ReportServiceProviders";
import security from "../../../common/mixins/security";
import Constants from '../../../common/constants'
import ReportRouting from "../components/ReportRouting";
import ReportVacancy from "../components/ReportVacancy";
import ReportWithParams from "../components/ReportWithParams";

export default {
    name: "Analytics",
    components: {
      ReportRouting,
      ReportServiceProviders,
      ReportPoll, 
      ReportRas,
      ReportVacancy,
      ReportWithParams
    },
    mixins: [security],
    data() {
        return {
            activeItem: '',
            accessRights: {
              patientRegistry: false,
              groupOfRisk: false,
              routing: false,
              serviceProviders: false,
              employment: false
            },
            nn: 0
        }
    },
    created() {
      this.checkPermission(Constants.ReportPatientRegistry).then((res) => {
        this.accessRights.patientRegistry = res.data;
        if (this.accessRights.patientRegistry) {
          this.activeItem = 'tab1';
        }
      });
      this.checkPermission(Constants.ReportGroupOfRisk).then((res) => {
        this.accessRights.groupOfRisk = res.data;
        if (!this.activeItem && this.accessRights.groupOfRisk) {
          this.activeItem = 'tab2';
        }
      });
      this.checkPermission(Constants.ReportRouting).then((res) => {
        this.accessRights.routing = res.data;
        if (!this.activeItem && this.accessRights.routing) {
          this.activeItem = 'tab3';
        }
      });
      this.checkPermission(Constants.ReportServiceProviders).then((res) => {
        this.accessRights.serviceProviders = res.data;
        if (!this.activeItem && this.accessRights.serviceProviders) {
          this.activeItem = 'tab4';
        }
      });
      this.checkPermission(Constants.ReportEmployment).then((res) => {
        this.accessRights.employment = res.data;
        if (!this.activeItem && this.accessRights.employment) {
          this.activeItem = 'tab5';
        }
      });
    },
    methods: {
        isActive (menuItem) {
            return this.activeItem === menuItem
        },
        setActive (menuItem) {
            this.activeItem = menuItem;
            if(this.activeItem == "tab6") 
              this.nn++;
        }
    },
}
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";
.nav-tabs {
  margin-top: 20px;
  justify-content: center;
  border: none;
  .nav-item {
    max-width: 205px;
    width: 100%;
    &:not(:last-child){
      margin-right: 16px;
    }
    .nav-link {
      padding: 7.5px 17.5px;
      text-align: center;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}

.content{
  padding: 32px ;
  position: relative;
  overflow-y: visible;
}
</style>